import { Grid, IconButton } from "@mui/material";
import React from "react";
import { ClearRounded } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const ViewPayment = (props) => {
  const { t } = useTranslation();
  const { setShowForm, viewData } = props;
  const handleClose = () => {
    setShowForm(false);
  };

  return (
    <>
      {viewData && (
        <Grid container spacing={3} className="p-15 dark-color mb-10">
          <Grid item xs={12}>
            <div className="mb-15 d-flex j-between a-center">
              <div>
                <span
                  className="fs-20 mb-5 fw-5 gray-color tx-upp
                    border-left"
                >
                  {t("View Payment")}
                </span>
              </div>

              <div>
                <IconButton onClick={handleClose} size="small" className="mr-5">
                  <ClearRounded className="fs-20 m-2" />
                </IconButton>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color grayMD-color">
              {t("PaymentId")}:
            </span>
            <span className="fs-18 fw-4 gray-color">{viewData.id}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("Member")}:
            </span>
            <span className="fs-16 fw-4 gray-color gray-color">
              {viewData.member && viewData.member}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("Invoice")}:
            </span>
            <span className="fs-18 fw-4 gray-color">{viewData.inv}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("Amount")}:
            </span>
            <span className="fs-18 fw-4 gray-color">{viewData.amount}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("PaymentMethod")}:
            </span>
            <span className="fs-18 fw-4 gray-color">{viewData.method}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("ReferenceNo")}
            </span>
            <span className="fs-18 fw-4 gray-color">{viewData.refe}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("PayDate")}
            </span>
            <span className="fs-18 fw-4 gray-color">{viewData.payDate}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("CreateUser")}
            </span>
            <span className="fs-18 fw-4 gray-color">
              {viewData.addedUser &&
                viewData.addedUser.firstName +
                  " " +
                  viewData.addedUser.lastName}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("CreateDate")}
            </span>
            <span className="fs-18 fw-4 gray-color">{viewData.addedDate}</span>
          </Grid>
          <Grid item xs={12} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">{t("Note")}:</span>
            <span className="fs-18 fw-4 gray-color">{viewData.note}</span>
          </Grid>
          <Grid item xs={12} className="d-grid">
            <span className="tx-xs tx-upp mb-5 gray-color ">
              {t("ViewFile")}:
            </span>
            {viewData.paymentFiles.map((file, i) => (
              <a
                key={i}
                href={file.fileUrl}
                className="mb-10 link fs-14"
                target="_blank"
                rel="noreferrer"
              >
                {file.name}
              </a>
            ))}
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default ViewPayment;
